import { z } from 'zod';
import { ICompany } from './ICompany';
import { ILegalTransaction } from './ILegalTransaction';

// Backend-Vertrag ist nicht ganz konsistent — daher liberal:
// - mehrere Felder werden je nach Endpoint mal geliefert, mal nicht
// - `allowDataChange` kommt als 0/1, im Frontend wollen wir aber boolean
const looseBoolean = z
  .union([z.boolean(), z.number()])
  .transform(v => Boolean(v));

export const ContactSchema = z.object({
  FirstName: z.string(),
  LastName: z.string(),
  idContact: z.number().int(),
  idCompany: z.number().int().optional(),
  idGender: z.number().int(),
  idAcademicTitle: z.number().int(),
  idBusinessForm: z.number().int(),
  Email: z.string(),

  Birthday: z.string().nullable().optional(),
  Birthplace: z.string().nullable().optional(),
  PhoneNumber: z.string().nullable(),
  passwordResetRequired: z.boolean().optional(),
  loginPossible: z.boolean().optional(),

  resetPassword: z.boolean().optional(),
  Login: z.string().optional(),
  Password: z.string().optional(),

  // aus Relationen — werden vom Backend nicht garantiert mitgeliefert
  Postcode: z.string().optional(),
  City: z.string().optional(),
  DateOfDeath: z.string().nullable().optional(),
  PlaceOfDeath: z.string().nullable().optional(),

  // Backend liefert das aktuell als 0/1; wir transformieren zu boolean
  allowDataChange: looseBoolean.optional(),
});

export type IContact = z.infer<typeof ContactSchema>;

// Reichere Strukturen werden weiterhin per Interface-Composition typisiert,
// solange ICompany / ILegalTransaction noch nicht auf Zod umgestellt sind.
export type IContactFullObject = IContact & {
  CompanyObject: ICompany;
  LegalTransactionArray: ILegalTransaction[];
};

export type ILegalTransactionHasContact = IContactFullObject & {
  idLegalRole: number | null;
};
